import "./PageHeader.css";
import ButtonGroup from "../layout/ButtonGroup";
import Input from "../ui/InputForm"; // import your InputForm component

function PageHeader({ title, status, actions, showSearch = false, onSearchChange }) {
  return (
    <div className="page-header">
      <div className="page-title-wrapper">
        <h1 className="page-title">{title}</h1>
        {status && (
          <div className="page-status" role="status" aria-live="polite">
            <span className="loader" aria-hidden="true" />
            <span className="page-status-text">{status}</span>
          </div>
        )}
      </div>

      <div className="page-actions">
        {actions && (
          <ButtonGroup>
            {actions}
          </ButtonGroup>
        )}

        {showSearch && (
          <div className="page-search">
            <Input
              name="aanbieder"
              type="text"
              placeholder="Zoek"
              leftIcon="/icons/glass.png"
              labelHelpIcon="/icons/help-circle.png"
              wrapperClassName="filter-input-wrapper"
              inputClassName="filter-input"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
